// ══════════════════════════════════════════════════════════════
// COMPASS – Client Invitation Actions (fire-and-forget, no reducer)
// ══════════════════════════════════════════════════════════════
import { createActionGroup, props } from '@ngrx/store';
import { InvitationDto } from '../../api/models/invitation-dto';

export const ClientInvitationActions = createActionGroup({
  source: 'Client Invitation',
  events: {
    'Invite Client': props<{ invitation: InvitationDto }>(),
    /** kycProcessId: an invite into that existing process (US-027); absent for one that creates its own process. */
    'Invite Client Success': props<{ kycProcessId?: string }>(),
    /** emailError: the refusal is about the email (a staff account, an invalid address), for the dialog's field. */
    'Invite Client Failure': props<{
      error: string;
      kycProcessId?: string;
      status?: number;
      code?: string;
      emailError?: string;
    }>(),
  },
});
